export const PageHeaderTitle = ({title}: {title: string}) => {
  return (
    <div className="">
      <h1 className="mt-2 text-3xl font-bold text-center lg:text-4xl md:text-left">
        {title}
      </h1>
    </div>
  );
};
